import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["sendAddress","form"];

  formTargetConnected(){
    let deliveryTo = this.formTarget.querySelector("input[name='referral_form[delivery_to]']:checked");
    if (deliveryTo != undefined){
      this.changeAddressDisable(deliveryTo);
    }else{
      this.formTarget.querySelector("#same_address").disabled = true;
    }
  }

  changeDeliveryTo(event){
    const el = event.currentTarget;
    this.changeAddressDisable(el);
  }
  changeAddressDisable(deliveryTo){
    if (deliveryTo.value == "priscription") {
      this.formTarget.querySelector("#same_address").disabled = true;
      this.sendAddressTarget.disabled = true;
      this.formTarget.querySelector("#referral_form_send_post_code").value = null;
      this.formTarget.querySelector("#referral_form_send_prefecture").value = null;
      this.formTarget.querySelector("#referral_form_send_city").value = null;
      this.formTarget.querySelector("#referral_form_send_address").value = null;
    }else if(deliveryTo.value == "hospital"){
      this.formTarget.querySelector("#same_address").disabled = false;
      this.sendAddressTarget.disabled = false;
    }else{
      this.formTarget.querySelector("#same_address").disabled = true;
      this.sendAddressTarget.disabled = false;
    }
  }

  copy_address(e){
    if(e.target.checked){
      this.formTarget.querySelector("#referral_form_send_post_code").value = this.formTarget.querySelector("#referral_form_hospital_post_code").value
      this.formTarget.querySelector("#referral_form_send_prefecture").value = this.formTarget.querySelector("#referral_form_hospital_prefecture").value
      this.formTarget.querySelector("#referral_form_send_city").value = this.formTarget.querySelector("#referral_form_hospital_city").value
      this.formTarget.querySelector("#referral_form_send_address").value = this.formTarget.querySelector("#referral_form_hospital_address").value
    }
  }
}
